import {Injectable, inject, computed} from '@angular/core';
import { Router,NavigationEnd,ActivatedRoute } from '@angular/router';
import {HistoryStateService} from "~core/services/history-state.service";
import { filter, startWith, switchMap } from 'rxjs';
import {toSignal} from "@angular/core/rxjs-interop";


@Injectable({
  providedIn: 'root',
})
export class NavigateService {
  
  private history: HistoryStateService=inject(HistoryStateService);
  #router: Router=inject(Router);
  #route = inject(ActivatedRoute);

  title$ = this.#router.events.pipe(
      filter((evt) => evt instanceof NavigationEnd),
      startWith(null),
      switchMap(() => {
        return this.leaf.title;})
  );

  get leaf(): ActivatedRoute {
    let leaf = this.#route;
    while (leaf.firstChild) {
      leaf = leaf.firstChild;
    }
    //console.log("Leaf:",leaf);
    return leaf;
  }

  searchQuery = computed(() => this.history.filter);
 // page = computed(() => this.history.page);
  pageTitle  =toSignal<string|undefined>(this.title$);

  initFromUrl() {
    //console.log('initFromUrl');
    //console.log("Search:",this.searchQuery())
    this.clear();
    //this.history.initFromUrl();
  }

  updateSearch(filter: string) {
    this.history.updateState({filter});
  }

  clear(){
    this.history.clear();
    this.history.initFromUrl();
  }

  clearSearch() {
    this.history.clearSearch();
  }

  /*
  nextPage() {
    this.history.updateState({ page: this.page() + 1 });
  }
*/
  goHome() {
    this.#router.navigate(['/']);
  }

  goBack() {
     this.history.back();
  }

  navigateTo(path: string) {
   // this.nextPage();
    this.#router.navigate(['/'+path]);
  }

  resetApp() {
    this.history.clear();
    this.#router.navigateByUrl('/temp', { skipLocationChange: true }).then(() => {
      this.#router.navigate(['/']); 
    });
  }

}
